import { c as _c } from "react/compiler-runtime";
import { DragOverlay } from '@dnd-kit/core';
import React, { PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';
interface DragOverlayPortalProps extends PropsWithChildren {
  dropAnimation?: any;
  className?: string;
}
const DragOverlayPortal = t0 => {
  const $ = _c(4);
  const {
    children,
    dropAnimation,
    className
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== className || $[2] !== dropAnimation) {
    t1 = createPortal(<DragOverlay dropAnimation={dropAnimation} className={className}>{children}</DragOverlay>, document.body);
    $[0] = children;
    $[1] = className;
    $[2] = dropAnimation;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default DragOverlayPortal;